import { skipToken, useQuery } from '@tanstack/react-query'
import { agentsApi } from '../api/agents-api'
import { agentKeys } from '../api/query-keys'

export function useAgentOperationDetail(
  entityId: string | null,
  agentId: string | null,
  operationId: string | null,
) {
  return useQuery({
    queryKey: agentKeys.operation(entityId ?? '', agentId ?? '', operationId ?? ''),
    queryFn:
      entityId === null || agentId === null || operationId === null
        ? skipToken
        : () => agentsApi.getAgentOperationDetail(entityId, agentId, operationId),
    refetchInterval: (query) =>
      query.state.data?.operation.finishedAt === null ? 3000 : false,
  })
}
